import * as Sentry from "@sentry/vue"
import { Thumbmark } from "@thumbmarkjs/thumbmarkjs"

const INCLUDE_KEYS = [
  "audio",
  "canvas",
  "fonts",
  "hardware",
  "locales",
  "math",
  "permissions",
  "plugins",
  "screen",
  "system",
  "webgl"
]
const EXCLUDE_KEYS = ["screen.resolution"]

export const getFingerPrint = async () => {
  try {
    const t = new Thumbmark({
      stabilize: ["private", "iframe"],
      include: INCLUDE_KEYS,
      exclude: EXCLUDE_KEYS
    })

    const tm = await t.get()

    const { thumbmark, components, version } = tm

    const reponse = {
      fingerprint: thumbmark,
      fingerprintCanvas: components?.canvas?.commonPixelsHash ?? null,
      fingerprintWebGL: components?.webgl?.commonPixelsHash ?? null,
      audio: components.audio,
      fonts: components.fonts,
      hardware: components.hardware,
      locales: components.locales,
      math: components.math,
      permissions: components.permissions,
      plugins: components.plugins,
      screen: components.screen,
      system: components.system,
      thumbmarkjsVersion: version
    }

    return reponse
  } catch (error) {
    console.error("initFingerPrint error", error)
    Sentry.captureException(error, {
      tags: { source: "accountTracker", context: "thumbmark" }
    })
    // captureException 受 prod sampleRate 抽樣；Logs 不抽樣，每筆失敗都會送出
    Sentry.logger.error("[accountTracker] thumbmark failed", {
      userId: useAuthStore().userID,
      userAgent: navigator.userAgent,
      errorMessage: error instanceof Error ? error.message : String(error)
    })
  }

  return null
}

export default getFingerPrint
